<template>
  <v-navigation-drawer
    v-model="open"
    width="300"
    fixed
    clipped
    app
    dark
    class="grey darken-3"
  >
    <template v-slot:prepend>
      <v-list-item @click="handleHomeClick()">
        <v-list-item-avatar>
          <img src="@/assets/logo.png" alt="Logo" width="32px" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Agro Fernheim</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>

    <v-list class="py-0" v-if="esAdmin" expand>
      <v-list-item :to="{ name: 'Administracion' }" color="primary">
        <v-list-item-icon>
          <v-icon>fa-user-shield</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Admin</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <v-list class="py-0" expand>
      <v-list-group prepend-icon="fa-cog" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Configuración</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          v-for="configuracion in configuracionGanaderiaList"
          :key="configuracion.title"
          :to="{ name: configuracion.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ configuracion.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ configuracion.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <v-list-group prepend-icon="fa-boxes" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Inventario</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item :to="{ name: 'ConfiguracionLotes' }" color="primary">
          <v-list-item-icon>
            <v-icon>fa-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Configuración de lotes</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'InventarioAnimal' }" color="primary">
          <v-list-item-icon>
            <v-icon>{{ cowIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inventario de ganado</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'MovimientosGanaderos' }" color="primary">
          <v-list-item-icon>
            <v-icon>fa-exchange-alt</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Movimientos de ganado</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'Prenez' }" color="primary">
          <v-list-item-icon>
            <v-icon>{{ prenezIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Preñez</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <v-list-group prepend-icon="fa-dollar-sign" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Finanzas</v-list-item-title>
          </v-list-item>
        </template>
        <fh-ganaderia-menu-search></fh-ganaderia-menu-search>

        <v-list-item
          v-for="concepto in listaFiltradaConceptos"
          :key="concepto.idConcepto"
          :to="{
            name: 'Movimiento',
            params: { conceptoSlug: concepto.conceptoSlug },
          }"
        >
          <v-list-item-icon> </v-list-item-icon>
          <v-list-item-title>{{ concepto.nombre }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <v-list-item :to="{ name: 'ResumenGanaderia' }" color="primary">
        <v-list-item-icon>
          <v-icon>fa-chart-bar</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Resumen</v-list-item-title>
      </v-list-item>

      <v-divider v-if="esAdmin"></v-divider>

      <v-list-group v-if="esAdmin" prepend-icon="fa-chart-line" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Estadisticas</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item :to="{ name: 'EstadisticasGanaderia' }" color="primary">
          <v-list-item-icon>
            <v-icon>fa-solid fa-chart-column</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Estadísticas ganadería</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'Estadisticas' }" color="primary">
          <v-list-item-icon>
            <v-icon>fas fa-chart-area</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Estadísticas agricultura</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mdiCow, mdiReproduction } from "@mdi/js";
import FhGanaderiaMenuSearch from "@/components/app/FhGanaderiaMenuSearch";
export default {
  name: "FhGanaderiaNavDrawer",
  props: {
    drawer: Boolean,
  },
  components: {
    FhGanaderiaMenuSearch,
  },
  data() {
    return {
      open: true,
      cowIcon: mdiCow,
      prenezIcon: mdiReproduction,
      configuracionGanaderiaList: [
        { title: "Máquinas", icon: "fa-tractor", route: "Maquinas" },
        { title: "Personal", icon: "fa-users", route: "Personal" },
      ],
    };
  },
  computed: {
    ...mapState("admin", ["esAdmin"]),
    ...mapGetters("establecimientos", [
      "currentCategoria",
    ]),
    ...mapGetters("conceptos", ["listaFiltradaConceptos"]),
    isRestrictedView() {
      return (
        this.$route.name === "ElegirAgricultor" ||
        this.$route.name === "CrearEstablecimiento"
      );
    },
  },
  watch:{
    drawer(){
      this.open = this.drawer
    }
  },
  methods: {
    handleHomeClick() {
      if (this.currentCategoria === 1) {
        this.$router.push({ name: "AgroHome" }).catch(() => {});
      } else {
        this.$router.push({ name: "GanaderiaHome" }).catch(() => {});
      }
    },
  },
};
</script>

<style>
</style>